import React, { useState, useEffect } from 'react';
import { Alert } from 'antd';
import NavBar from './NavBar';
import Footer from './Footer';
import WhatsNewRibbon from '../components/Roadmap/WhatsNewRibbon';
import useBackendHealth from '../hooks/use_backend_health';

function Layout({ children }) {
  const isBackendReachable = useBackendHealth();
  const [wasEverUnreachable, setWasEverUnreachable] = useState(false);
  const [errorDismissed, setErrorDismissed] = useState(false);

  useEffect(() => {
    if (!isBackendReachable) {
      setWasEverUnreachable(true);
      setErrorDismissed(false);
    }
  }, [isBackendReachable]);

  return (
    <>
      {wasEverUnreachable && !errorDismissed && (
        <Alert
          message={isBackendReachable ? 'Connection restored.' : 'Cannot reach the backend — some features may be unavailable.'}
          type={isBackendReachable ? 'success' : 'error'}
          banner
          closable
          onClose={() => setErrorDismissed(true)}
          style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999 }}
        />
      )}
      <NavBar />
      <WhatsNewRibbon />
      <main className="main-above-footer">
        {children}
      </main>
      <Footer />
    </>
  );
}

export default Layout;